<template>
    <RegularModal ref="modal">
        <template v-slot:title>
            {{ translate("live_streams.add") }}
        </template>
        <template v-slot:body>
            <div class="columns">
                <div class="column">
                    <div class="field">
                        <label class="label">
                            {{ translate("live_streams.select_mat") }}
                        </label>

                        <div class="control">
                            <div class="select is-fullwidth">
                                <select v-model="selectedMatId">
                                    <option :value="0">----</option>
                                    <option v-for="mat in eligibleMatsForAddingStream" :key="mat.id" :value="mat.id">
                                        {{ mat.name }}
                                    </option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div>
                        <label class="label">{{ translate("live_streams.choose_platform") }}</label>

                        <div class="tabs is-boxed mb-3">
                            <ul>
                                <li class="is-active">
                                    <a>{{ translate("live_streams.vendor.BasicYoutube") }}</a>
                                </li>
                            </ul>
                        </div>

                        <div class="box">
                            <div class="field" :class="getFormGroupClass('basicYoutubeVideoUrl')">
                                <label class="label">
                                    {{ translate("live_streams.basic_yt_input") }}
                                </label>
                                <div class="control">
                                    <input class="input" v-model="basicYoutubeVideoUrl" type="text" />
                                </div>
                                <p class="help">
                                    {{ getValidationMessage("basicYoutubeVideoUrl") }}
                                </p>
                            </div>

                            <p class="help">
                                {{ translate("live_streams.basic_yt_input_desc") }}
                                <br />
                                <a :href="helpCenter().howToStartLiveStreaming()" target="_blank"
                                    >{{ translate("page.welcome.faq.read_more") }}
                                </a>
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </template>
        <template v-slot:footer>
            <div class="buttons">
                <button class="button" @click="close">
                    <span class="icon">
                        <i class="fas fa-times"></i>
                    </span>
                    <span>{{ translate("common.cancel") }}</span>
                </button>
                <LoadingButton
                    :is-loading="addingInProgress"
                    class="button is-primary"
                    :disabled="!canCreateStream"
                    @click="createLiveStream"
                >
                    <span class="icon">
                        <i class="fas fa-plus"></i>
                    </span>
                    <span>{{ translate("common.add") }}</span>
                </LoadingButton>
            </div>
        </template>
    </RegularModal>
</template>

<script>
    import RegularModal from "../Common/RegularModal.vue";
    import translatorMixin from "../Common/translatorMixin";
    import { mapGetters, mapState } from "vuex";
    import apiMixin from "../Api/apiMixin";
    import LoadingButton from "../Common/LoadingButton.vue";
    import errorHandlerMixin from "../Common/errorHandlerMixin";
    import validationErrorMixin from "../Common/validationErrorMixin";
    import urlsMixin from "../Urls/urlsMixin";

    const VENDOR_BASIC_YOUTUBE = "BasicYoutube";

    export default {
        name: "add-live-stream-modal",
        components: { LoadingButton, RegularModal },
        mixins: [translatorMixin, apiMixin, errorHandlerMixin, validationErrorMixin, urlsMixin],
        data() {
            return {
                addingInProgress: false,
                selectedMatId: 0,

                selectedVendor: VENDOR_BASIC_YOUTUBE,

                basicYoutubeVideoUrl: "",
            };
        },
        computed: {
            ...mapState("main", ["eventId"]),
            ...mapGetters("main", ["eligibleMatsForAddingStream"]),
            canCreateStream() {
                if (!this.selectedMatId) {
                    return false;
                }

                if (this.selectedVendor === VENDOR_BASIC_YOUTUBE && !this.basicYoutubeVideoUrl) {
                    return false;
                }

                return true;
            },
        },
        methods: {
            open() {
                this.clearValidationErrors();
                this.selectedMatId = 0;
                this.basicYoutubeVideoUrl = "";
                this.selectedVendor = VENDOR_BASIC_YOUTUBE;

                this.$refs.modal.open();
            },
            close() {
                this.$refs.modal.close();
            },
            createLiveStream() {
                if (!this.selectedMatId) {
                    return;
                }

                this.addingInProgress = true;

                return this.liveStreamsApi()
                    .createLiveStream(this.eventId, this.selectedMatId, this.selectedVendor, this.getMetadata())
                    .then(() => {
                        this.close();

                        return this.$store.dispatch("main/refreshLiveStreams");
                    })
                    .catch(err => {
                        this.updateValidationErrors(err.validationErrors);

                        return this.handleError(err);
                    })
                    .finally(() => {
                        this.addingInProgress = false;
                    });
            },
            getMetadata() {
                if (this.selectedVendor === VENDOR_BASIC_YOUTUBE) {
                    return {
                        videoUrl: this.basicYoutubeVideoUrl,
                    };
                }

                return {};
            },
        },
    };
</script>

<style scoped></style>
